<template>
  <div class="form-container">
    <!-- 返回按钮 -->
    <button class="back-button" @click="goBack">← 返回抽奖</button>

    <h2 style="margin-top: 20px">奖品配置</h2>
    <form @submit.prevent="submitForm">
      <!-- 动态奖品列表 -->
      <div v-for="(prize, index) in prizes" :key="index" class="prize-item">
        <h3>奖品： {{ prize.fonts[0].text }}</h3>
        <div class="prize-row">
          <!-- 是否为奖项 -->
          <div class="prize-field">
            <label>是否为奖项:</label>
            <select v-model="prize.isPrize" required>
              <option value="1">是</option>
              <option value="0">否</option>
            </select>
          </div>

          <!-- 奖品文字 -->
          <div class="prize-field">
            <label>奖品文字:</label>
            <input
              type="text"
              v-model="prize.fonts[0].text"
              placeholder="请输入奖品文字"
              required
            />
          </div>

          <!-- 概率 -->
          <div class="prize-field">
            <label>中奖概率:</label>
            <input
              type="number"
              v-model="prize.range"
              step="0.01"
              placeholder="请输入概率"
              required
            />
          </div>

          <!-- 奖品图片 -->
          <div class="prize-field">
            <label>奖品图片:</label>
            <input
              type="file"
              accept="image/*"
              @change="handleFileUpload($event, index)"
            />
            <img v-if="prize.imgs[0].src" :src="prize.imgs[0].src" alt="图片预览" class="img-preview" />
          </div>

          <!-- 图片大小 -->
          <div class="prize-field">
            <label>图片大小:(以px结尾)</label>
            <input
              v-model="prize.imgs[0].width"
              placeholder="请输入大小(以px结尾)"
              required
            />
          </div>

          <!-- 删除奖品按钮 -->
          <div class="prize-field">
            <button type="button" class="delete-button" @click="removePrize(index)">删除</button>
          </div>
        </div>
      </div>

      <!-- 添加奖品按钮 -->
      <button type="button" class="add-button" @click="addPrize">添加奖品</button>

      <!-- 提交表单按钮 -->
      <button type="submit" class="submit-button">提交</button>
    </form>
    <Toast :message="toastMessage" :visible="showToast" @update:visible="showToast = $event" :type="toastType" />
  </div>
</template>

<script>
import Toast from './Toast.vue';
import {EventBus} from "../event-bus";
import { API_URL } from '../constant.js';
export default {
  components: {
    Toast
  },
  data() {
    return {
      showToast: false,
      toastMessage: '',
      toastType: 'success',
      // 初始的奖品列表
      prizes: [
        {
          isPrize : 1,
          fonts: [{ text: 'iPhone 16 Pro Max',top: '15%', }],
          background: "#FF5733",
          range: 15,
          imgs:[{top: '30%', width:"120px", src: `${API_URL}/uploads/file-1732960913008-503939608.png` }]
        }
      ],
    };
  },
  created() {
    this.fetchData()
  },
  methods: {
    async fetchData() {
      try {
        // 发送 GET 请求
        const response = await fetch(`${API_URL}/get-config`);
        this.prizes = await response.json(); // 将获取的数据存储到组件的 data 中
      } catch (error) {
        console.error("There was an error fetching the data:", error);
      }
    },

    // 发送 POST 请求的 set-config 方法
    async setConfig() {
      this.prizes = this.prizes.map((prize, index ) => {
        prize.background = index % 2 === 0 ? "#FF5733" : "#fc820a";
        return prize;
      })
      try {
        const response = await fetch(`${API_URL}/set-config`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json' // 设置请求体为 JSON 格式
          },
          body: JSON.stringify(this.prizes) // 将新配置转换为 JSON 字符串并发送
        });

        if (response.ok) {
          const data = await response.json();
          this.toastMessage = '配置完成';
          this.toastType = 'success';
        } else {
          this.toastMessage = '配置失败';
          this.toastType = 'error';
        }
        this.showToast = true;
      } catch (error) {
        this.toastMessage = 'There was an error sending the data';
        this.toastType = 'error';
        this.showToast = true;
      }
    },
    // 添加新的奖品项
    addPrize() {
      const background = this.prizes.length % 2 === 0 ? "#FF5733" : "#fc820a";
      this.prizes.push({
        isPrize : 1,
        fonts: [{ text: '奖品名称',top: '10%', }],
        background: background,
        range: 15,
        imgs:[{top: '20%', width:"120px", src: `${API_URL}/uploads/file-1732971127928-79697079.png` }]
      });
      console.log(this.prizes);
    },
    // 删除奖品项
    removePrize(index) {
      this.prizes.splice(index, 1);
    },
    // 处理图片文件上传
    handleFileUpload(event, index) {
      const file = event.target.files[0];
      if (file) {
        this.uploadFile(file, index)
      }
    },
    async uploadFile(file, index) {
      if (!file) {
        alert("Please select a file before uploading.");
        return;
      }

      const formData = new FormData();
      formData.append("file", file);

      try {
        const response = await fetch(`${API_URL}/upload`, {
          method: "POST",
          body: formData
        });

        if (response.ok) {
          const data = await response.json();
          this.prizes.splice(index, 1, {
            ...this.prizes[index],
            imgs: [{
              top: '30%',
              width:"180px",
              src: data.filePath
            }]
          });
        } else {
          console.error("Failed to upload file:", response.statusText);
        }
      } catch (error) {
        console.error("There was an error uploading the file:", error);
      }
    },
    // 提交表单
    submitForm() {
      this.setConfig()
    },
    // 返回按钮的功能
    goBack() {
      this.$emit('switch')
      EventBus.$emit('switch');
    },
  },
};
</script>

<style>
.form-container {
  background: #fff;
  padding: 20px 30px;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  max-width: 800px;
  margin: 0 auto;
  font-family: Arial, sans-serif;
  position: relative; /* 必须设置以便定位返回按钮 */
}

.back-button {
  width: 120px;
  height: 30px;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 10px;
  left: 10px;
  background-color: #007bff;
  color: #fff;
  border: none;
  padding: 5px 10px; /* 按钮尺寸缩小 */
  border-radius: 3px; /* 边框圆角更小 */
  font-size: 12px; /* 字体更小 */
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.back-button:hover {
  background-color: #0056b3;
}

h2, h3 {
  text-align: center;
  color: #333;
}

.prize-row {
  //height: 100px;
  display: flex;
  gap: 10px;
  align-items: flex-start;
  margin-bottom: 20px;
  border: 1px solid #ccc;
  padding: 10px;
  border-radius: 5px;
  background-color: #f9f9f9;
}

.prize-field {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
}

label {
  font-weight: bold;
  margin-bottom: 5px;
  color: #555;
}

input, select, button {
  width: 100%;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 5px;
  box-sizing: border-box;
}

input:focus, select:focus {
  border-color: #007bff;
  outline: none;
}

button {
  cursor: pointer;
  font-size: 14px;
  font-weight: bold;
}

.add-button, .delete-button {
  background-color: #28a745;
  color: #fff;
  border: none;
  margin-top: 10px;
  transition: background-color 0.3s ease;
}

.add-button:hover, .delete-button:hover {
  background-color: #218838;
}

.delete-button {
  background-color: #dc3545;
}

.delete-button:hover {
  background-color: #c82333;
}

.submit-button {
  margin-top: 20px;
  background-color: #007bff;
  color: #fff;
  border: none;
  transition: background-color 0.3s ease;
}

.submit-button:hover {
  background-color: #0056b3;
}

.img-preview {
  display: block;
  width: 80px;
  height: auto;
  margin-top: 5px;
  border: 1px solid #ccc;
  border-radius: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/settings.vue